export const tableHead = 'grid gap-3 border-b bg-muted px-3.5 py-2 text-[11.5px] font-semibold uppercase tracking-wide text-muted-foreground';
export const tableRow = 'grid items-center gap-3 border-b px-3.5 py-2.5 text-[13px] last:border-b-0';
